import {
  GET_ALL_ASSESSMENT_DETAILS,
  GET_ALL_ASSESSMENT_DETAILS_FAIL,
  GET_ALL_ASSESSMENT_DETAILS_SUCCESS,
  GET_ASSESSMENT_RECORD,
  GET_ASSESSMENT_RECORD_FAIL,
  GET_ASSESSMENT_RECORD_SUCCESS,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  successMessage: null,
  assessmentDetailsData: null,
  assessmentDetailData:null
};

const assessmentDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_ASSESSMENT_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_ASSESSMENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        assessmentDetailsData: action.payload,
      };
    case GET_ALL_ASSESSMENT_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case GET_ASSESSMENT_RECORD:
        return {
          ...state,
          loading: true,
          assessmentDetailData:null,
          error: null,
        };
      case GET_ASSESSMENT_RECORD_SUCCESS:
        return {
          ...state,
          loading: false,
          assessmentDetailData: action.payload,
        };
      case GET_ASSESSMENT_RECORD_FAIL:
        return {
          ...state,
          loading: false,
          assessmentDetailData:null,
          error: action.payload,
        };

    default:
      return state;
  }
};

export default assessmentDetailsReducer;
